import { PostJson } from "../core/Helper";

export class TokenService {
  static async GetToken(data, user) {
    let result = await PostJson("api/get-rcx-token", {
      data,
      user,
    });
    return result ?? null;
  }

  /** Token โปรแกรม ScannerPicker RcxScanner */
  static async GetScanToken(data, user) {
    let result = await PostJson("api/get-rcxscan-token", {
      data,
      user,
    });
    return result ?? null;
  }
}

export class RCXDicomLauncher {
  constructor(userDetail) {
    this.user = userDetail;
    this.protocolScheme = "rcx-dicom://";
  }

  async generateJWTToken() {
    try {
      let res = await TokenService.GetToken(null, this.user);
      return res?.token ?? "";
    } catch (error) {
      console.error("Error generating JWT token:", error);
      throw error;
    }
  }

  // เปิดโปรแกรมด้วย URL protocol
  async launchDicomOpener() {
    try {
      // แสดง loading
      this.showLoading(true);

      // สร้าง JWT token
      const token = await this.generateJWTToken();
      console.log("JWT Token generated successfully");

      // สร้าง launch URL
      const launchUrl = this.createLaunchURL(token);
      console.log("Launch URL:", launchUrl);

      // พยายามเปิดโปรแกรม
      this.attemptLaunch(launchUrl);
    } catch (error) {
      console.error("Error launching DICOM opener:", error);
      this.showError("Failed to launch DICOM opener: " + error.message);
    } finally {
      this.showLoading(false);
    }
  }

  // สร้าง URL สำหรับเปิดโปรแกรม
  createLaunchURL(token) {
    const encodedToken = encodeURIComponent(token);
    return `${this.protocolScheme}?token=${encodedToken}`;
  }

  // พยายามเปิดโปรแกรมด้วยวิธีต่างๆ
  attemptLaunch(launchUrl) {
    if (window.navigator.msLaunchUri) {
      // Internet Explorer/Edge
      window.navigator.msLaunchUri(
        launchUrl,
        () => console.log("App launched successfully"),
        () => this.showProtocolError()
      );
    } else {
      // Chrome, Firefox, Safari
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = launchUrl;
      document.body.appendChild(iframe);

      // ตรวจสอบว่าโปรแกรมเปิดหรือไม่
      setTimeout(() => {
        document.body.removeChild(iframe);
        // ถ้าหน้าต่างยังคงเป็น focus อยู่ แสดงว่าโปรแกรมอาจไม่เปิด
        if (document.hasFocus()) {
          this.showInstallPrompt();
        }
      }, 3000);
    }
  }

  // ถ้ายังไม่ได้ install ให้แสดงข้อความให้ติดตั้งโปรแกรมและให้ user ไปยังหน้า downloads
  showInstallPrompt() {
    const installPrompt = document.createElement("div");
    installPrompt.className = "install-prompt";
    installPrompt.innerHTML = `
            <div class="install-content">
                <h4>DICOM Opener Not Found</h4>
                <p>The RCX DICOM Opener application is not installed or not responding.</p>
                <div class="install-actions">
                    <button onclick="window.open('https://radconnext.com/downloads', '_blank')">
                        Download Installer
                    </button>
                    <button onclick="this.parentElement.parentElement.parentElement.remove()">
                        Cancel
                    </button>
                </div>
            </div>
        `;
    document.body.appendChild(installPrompt);
  }

  // แสดงข้อผิดพลาดเกี่ยวกับ protocol
  showProtocolError() {
    this.showError(
      "Custom protocol not supported or application not installed"
    );
    setTimeout(() => this.showInstallPrompt(), 2000);
  }
}
